import { Col, Container, Row } from 'react-bootstrap'
import { usePlatform } from 'src/business/context/platform-context'
import { LoginBannerApollo } from 'src/component/auth/login-banner-apollo'
import { LoginBannerWincanton } from 'src/component/auth/login-banner-wincanton'
import { HaulierSignUpBanner } from 'src/component/haulier-sign-up/haulier-sign-up-banner'
import { HaulierSignUpForm } from 'src/component/haulier-sign-up/haulier-sign-up-form'

export const HaulierSignUpScreen = (): React.ReactElement => {

  const { isEyeQMarketplace, isAtom, isZeus } = usePlatform()

  const banners = {
    Zeus: <HaulierSignUpBanner />,
    EyeQ: isEyeQMarketplace && <LoginBannerWincanton />,
    Atom: isAtom && <LoginBannerApollo />
  }

  return (
    <Container fluid={true}>
      <Row className="signup-background-color">
        <Col md={8} className="p-0 d-none d-sm-block">
        {isZeus && banners.Zeus}
        {isEyeQMarketplace && banners.EyeQ}
        {isAtom && banners.Atom}
        </Col>
        <Col xs={6} md={4} className="d-grid gap-3">
          <HaulierSignUpForm />
        </Col>
      </Row>
    </Container>
  )
}
